import { Link } from 'react-router-dom';
import { categories, getArticlesByCategory } from '@/utils/articles';

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {categories.map((c) => {
        const count = getArticlesByCategory(c.slug).length;
        return (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-bold text-foreground-950">{c.name}</span>
              <span className="clamp-1 block text-xs text-foreground-500">{c.description}</span>
              <span className="mt-0.5 block text-xs font-medium text-primary-600">
                共 {count} 条爆料
              </span>
            </span>
          </Link>
        );
      })}
    </div>
  );
}